export default __webpack_public_path__ + "static/CentraNo2-BoldItalic-a6c9503108d726a0bda6063d3f3e2bc8.woff2";